<div *ngIf="totalInOut | async as totalInOut">
  <p class="cash-in">{{ totalInOut.in | currency: "TND" }}</p>
  <p class="cash-out">{{ totalInOut.out | currency: "TND" }}</p>
</div>
